<template>
  <div class="activate-search-bar">
    <el-row class="flex flex-row w-full justify-between items-end">
      <div class="w-[228px]">
        <input
          v-model="model.searchText"
          @input="handleInputChange"
          :placeholder="$t('label.search')"
          class="border-0 border-b outline-hidden border-[#9FA0AD] bg-transparent text-base text-black w-full text-base font-light placeholder:text-[#a8abb2]"
        />
      </div>
    </el-row>
  </div>
</template>

<script src="./activate-searchbar.js"></script>
